import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["isArray", "start", "level", "className", "render"];
import { Label } from '../value';
import { jsx as _jsx } from "react/jsx-runtime";
export function Meta(props) {
  var {
      isArray = false,
      start = false,
      level,
      className,
      render
    } = props,
    reset = _objectWithoutPropertiesLoose(props, _excluded);
  var mark = isArray ? '[]' : '{}';
  var cls = "w-rjv-" + (isArray ? 'brackets' : 'curlybraces') + "-" + (start ? 'start' : 'end') + " " + (className || '');
  var color = "var(--w-rjv-" + (isArray ? 'brackets' : 'curlybraces') + "-color, #236a7c)";
  if (render) {
    var viev = render(_extends({
      isArray,
      level,
      className: cls,
      style: {
        color
      },
      children: start ? mark.charAt(0) : mark.charAt(1)
    }, reset));
    if (viev) {
      return viev;
    }
  }
  return /*#__PURE__*/_jsx(Label, _extends({
    color: color,
    className: cls
  }, reset, {
    children: start ? mark.charAt(0) : mark.charAt(1)
  }));
}